export const truncateText = (text: string) => text.replace(/(^\s*)|(\s*$)/gi, '')
  .replace(/[ ]{2,}/gi, ' ')
  .replace(/\n /, '\n');
